/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Org_TitleInputs */

const da_settings_org_title = /** @type {(inputs: Settings_Org_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisation`)
};

/** @type {(inputs: Settings_Org_TitleInputs) => LocalizedString} */
const en_settings_org_title = da_settings_org_title;

/**

* @param {Settings_Org_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_org_title = /** @type {((inputs?: Settings_Org_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Org_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_org_title(inputs)
	return /** @type {LocalizedString} */ ("Organisation")
});